import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import { CircularProgress } from 'material-ui';
import Modal from 'react-modal';

import { shouldEdit } from 'utils/valuesByKey';
import PanelTable from '../panels/PanelTable';
import DetailList from '../DetailList';
import RootForm from '../form/RootForm';
import Alert from '../Alert';
import * as CRUDActions from '../../actions/EntityCRUD';

Modal.setAppElement('#app');

class EditPanel extends Component {
  constructor(props) {
    super(props);
    /* Initialize the container dialogs as closed and empty */
    this.state = {
      open: false, dialogContent: [], editMode: false, alertOpen: false,
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyPress);
    this.props.onOpen && this.props.onOpen();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyPress);
  }

  onKeyPress = (event) => {
    if (event.keyCode === 27 && this.state.open) {
      this.closeDialog();
    }
  }

  closeAlert = () => this.setState({ alertOpen: false });
  closeDialog = () => {
    this.setState({
      open: false, editMode: false, dialogContent: [], dialogModel: null,
    });
  };
  openDialog = () => this.setState({ open: true });

  /* Add actions to the model being displayed in the table */
  mapActions = (model) => {
    const dialogContent = model.detailFields.filter(f => model[f]).map(f => model[f]);
    return {
      ...model,
      actions: [{
        label: <FormattedMessage id="editPanel.detail" />,
        action: () => this.setState({ dialogContent, open: true, dialogModel: model }),
      }],
    };
  }

  /* Open edit modal for the model, empty if newEntity param is set to true */
  editMode = (newEntity) => {
    const { dialogContent, dialogModel } = this.state;
    let fields;
    if (newEntity) {
      const { EmployeeMasterID, mapModel } = this.props;
      /* Create a new entity with the EmployeeMasterID of the user */
      const newEd = mapModel({ Entity: { EmployeeMasterID } });
      fields = newEd.detailFields.map(f => newEd[f])
        .filter(f => f.entity)
        .map(c => ({
          label: c.label,
          name: c.entity,
          value: newEd.Entity[c.entity],
          ...newEd.entityMap[c.entity],
        }));
      /* Open the dialog */
      this.setState({
        save: false, editMode: true, fields, dialogModel: newEd,
      }, this.setState({ open: true }));
    } else {
      fields = dialogContent.filter(f => f.entity).map(c => ({
        label: c.label,
        name: c.entity,
        value: dialogModel.Entity[c.entity],
        ...dialogModel.entityMap[c.entity],
      }));
      /* Open the dialog */
      this.setState({ save: true, editMode: true, fields });
    }
  }

  save = () => {
    if (this.ctl.isInvalid()) {
      return;
    }
    // If entity is new we need to use `create`
    this.state.save ? this.ctl.save() : this.ctl.create();
    this.closeDialog();
  }

  delete = () => {
    const { props: { dispatch, fetchData, modelName }, state: { dialogModel: { Entity } } } = this;
    dispatch(CRUDActions.remove(modelName, Entity, fetchData));
    this.closeAlert();
    this.closeDialog();
  }

  validate = (values) => {
    const { valuesByKey, modelName } = this.props;
    const requiredFields = valuesByKey[`Required.${modelName}`] ? valuesByKey[`Required.${modelName}`].Value.split(',') : [];
    const error = {};
    requiredFields.forEach((r) => {
      const value = values[r];
      if (!value && value !== 0 && value !== false) {
        error[r] = <FormattedMessage id="editPanel.required" />;
      }
    });
    return error;
  }

  render() {
    const {
      modelName,
      dataSource,
      fetchData,
      initSort,
      dispatch,
      valuesByKey,
      loaded,
      emptyText,
    } = this.props;
    const {
      dialogContent,
      dialogModel,
      editMode,
      alertOpen,
      fields,
    } = this.state;
    const dataWithActions = dataSource && dataSource.map(this.mapActions);

    const actions = shouldEdit(valuesByKey, modelName) ? [
      editMode ? undefined :
      <RaisedButton
        label={<FormattedMessage id="editPanel.edit" />}
        style={{ marginRight: 8 }}
        primary
        key="edit"
        onClick={() => this.editMode(false)}
      />,
      editMode ? undefined :
      <RaisedButton
        label={<FormattedMessage id="editPanel.delete" />}
        secondary
        key="delete"
        onClick={() => this.setState({ alertOpen: true })}
      />,
    ] : [];

    const saveActions = shouldEdit(valuesByKey, modelName) ? [
      !editMode ? undefined :
      <RaisedButton
        label={<FormattedMessage id="editPanel.save" />}
        primary
        key="save"
        onClick={this.ctl && this.ctl.handleSubmit(this.save)}
      />,
      <RaisedButton
        label={<FormattedMessage id="alert.cancel" />}
        onClick={this.closeDialog}
        style={{ marginLeft: 8 }}
      />,
    ] : [];

    const panelActions = (
      <div key="actions" style={{ display: 'flex', justifyContent: 'space-between' }}>
        {shouldEdit(valuesByKey, modelName) &&
        <RaisedButton
          label={<FormattedMessage id="editPanel.add" />}
          primary
          onClick={() => this.editMode(true)}
        />
        }
        <FlatButton
          label={<FormattedMessage id="editPanel.refresh" />}
          icon={<FontIcon className="material-icons">refresh</FontIcon>}
          primary
          onClick={() => dispatch(fetchData())}
        />
      </div>
    );

    return (
      <div>
        {loaded && <PanelTable emptyText={emptyText} dataSource={dataWithActions} actions initSort={initSort} />}
        {!loaded &&
          <div
            style={{
              height: 80,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress mode="indeterminate" thickness={4} />
          </div>
        }

        <Modal
          isOpen={this.state.open}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <div style={{ height: '64vh' }}>
            <IconButton
              style={{ margin: -12, float: 'right' }}
              iconClassName="material-icons"
              onClick={this.closeDialog}
            >
              close
            </IconButton>
            {editMode ?
              <div style={{ minWidth: '50vw' }}>
                <RootForm
                  formName={modelName}
                  // ref={(rf) => { this.rootForm = rf; }}
                  fields={fields}
                  initialValues={dialogModel.Entity}
                  provideController={(ctl) => { this.ctl = ctl; }}
                  // function to be dispatched once request completes
                  dataFetch={fetchData}
                  validate={this.validate}
                />
                <div style={{ marginTop: 16 }}>
                  {saveActions}
                </div>
              </div>
              :
              <React.Fragment>
                <DetailList dataSource={dialogContent} />
                <div style={{ marginTop: 16 }}>
                  {actions}
                </div>
              </React.Fragment>
            }
          </div>
        </Modal>
        <div style={{ padding: 12 }}>{panelActions}</div>
        <Alert
          open={alertOpen}
          onOk={this.delete}
          onCancel={this.closeAlert}
          text={<FormattedMessage id="editPanel.alert" />}
        />
      </div>
    );
  }
}

EditPanel.propTypes = {
  modelName: PropTypes.string.isRequired,
  emptyText: PropTypes.string,
  mapModel: PropTypes.func.isRequired,
  EmployeeMasterID: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  dataSource: PropTypes.array,
  initSort: PropTypes.string,
  valuesByKey: PropTypes.object,
  loaded: PropTypes.bool,
};

EditPanel.defaultProps = {
  dataSource: [],
  initSort: '',
};

export default connect(({ WebValuesReducer }) => ({ valuesByKey: WebValuesReducer.valuesByKey }))(EditPanel);



// WEBPACK FOOTER //
// ./src/components/profile/EditPanel.js